import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ArztDatenResponse, ClientService } from '../../api/client.service';
import { merge, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'san-basis-daten-eingabe-zwei',
  templateUrl: './basis-daten-eingabe-zwei.component.html',
  styleUrls: ['./basis-daten-eingabe-zwei.component.scss'],
  standalone: false,
})
export class BasisDatenEingabeZweiComponent implements OnInit {
  @HostBinding('class.d-block') dblock = true;
  @HostBinding('class.h-100') h100 = true;

  @Input() state!: ArztDatenResponse;
  @Input() baseDataForm!: FormGroup;
  @Input() krankenkassen!: { name: string; id: number }[];
  @Input() userParams!: {
    tnz_beginn: string;
    uuid: string;
    versorgungsVertragID: number;
    vertragsgruppe: number;
    action?: string;
  };

  @Output() ready = new EventEmitter<void>();
  @Output() zurueck = new EventEmitter<void>();
  @Output() invalid = new EventEmitter<number>();
  @Output() vertragGeladen = new EventEmitter<void>();

  krankenkasse: unknown;

  krankenkasseAuswahlConfig = {
    titleFocused$: new Subject<string>(),
    titleClicked$: new Subject<string>(),
    titleSelected$: new Subject<string>(),
    // noinspection JSUnusedGlobalSymbols
    titleAuswahl: (text$: Observable<string>) => {
      const debouncedText$ = text$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
      );
      // const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
      const inputFocus$ = this.krankenkasseAuswahlConfig.titleFocused$;
      return merge(
        debouncedText$,
        inputFocus$,
        this.krankenkasseAuswahlConfig.titleClicked$,
        this.krankenkasseAuswahlConfig.titleSelected$,
      ).pipe(
        map((term) =>
          this.krankenkassen.filter(
            (v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1,
          ),
        ),
      );
      // tslint:disable-next-line:semicolon
    },
  };

  constructor(private clientService: ClientService) {}

  formatter = (x: { name: string }) => x.name;

  ngOnInit(): void {}

  checkReady() {
    this.baseDataForm.get('versicherten_nummer').markAsDirty();
    this.baseDataForm.get('email').markAsDirty();
    this.baseDataForm.get('krankenkasse').markAsDirty();

    const formValid =
      this.baseDataForm.get('versicherten_nummer').valid &&
      this.baseDataForm.get('email').valid &&
      this.baseDataForm.get('krankenkasse').valid;

    if (!formValid) {
      return;
    }

    this.clientService
      .getKrankenkasseAvailability(
        this.userParams.uuid,
        this.userParams.versorgungsVertragID,
        this.userParams.vertragsgruppe,
        (
          this.baseDataForm.get('krankenkasse') as FormControl<{
            name: string;
            id: number;
          }>
        ).value.id,
      )
      .subscribe((r) => {
        if (r.issue === 0) {
          this.clientService
            .getVertragDaten(
              this.userParams.uuid,
              this.userParams.versorgungsVertragID,
              this.userParams.vertragsgruppe,
              (
                this.baseDataForm.get('krankenkasse') as FormControl<{
                  name: string;
                  id: number;
                }>
              ).value.id,
            )
            .subscribe((response) => {
              this.state.vertrag = response.vertrag;
              this.vertragGeladen.emit();
            });
          this.state.tnzCheck$.next({
            ae: r.ae,
            vertrag: r.vertrag,
            kkBeitritt: r.kkBeitritt,
          });
          this.ready.emit();
        } else {
          this.invalid.emit(r.issue as number);
        }
      });
  }

  checkReadyOld() {
    for (const controlName in this.baseDataForm.controls) {
      if (!this.baseDataForm.controls.hasOwnProperty(controlName)) {
        continue;
      }
      this.baseDataForm.controls[controlName].markAsDirty();
    }
    if (this.baseDataForm.valid) {
      this.ready.emit();
    }
  }

  setKrankenkasse(
    $event: NgbTypeaheadSelectItemEvent<{ name: string; id: number }>,
  ) {
    this.baseDataForm.patchValue({ krankenkasse: $event.item });
  }
}
